<template>
  <div class="flex flex-col gap-1.5 text-text-body-default text-m-medium w-full">
    <div
      v-for="item in itemList"
      :key="item.label"
      class=""
      :class="[
        'px-2 py-1.5 flex items-center gap-2 w-full',
        'rounded-4xl text-text-glass-default transition-colors',
        'hover:text-text-glass-hover hover:bg-neutral-light-default',
        'active:bg-white-black active:text-black-white',
        item.action && 'cursor-pointer',
      ]"
      @click="handleItemClick(item.action)"
    >
      <p>{{ item.label }}{{ item.value ? ':' : '' }}</p>
      <p class="overflow-hidden text-ellipsis max-w-40">{{ item.value }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useLocaleStore, useUserStore } from '@/stores'

  const userStore = useUserStore()
  const { t } = useLocaleStore()
  const emit = defineEmits<{
    (e: 'open-change-password'): void
    (e: 'open-bind-account'): void
    (e: 'open-bind-wx'): void
  }>()

  const { userInfo } = storeToRefs(userStore)

  type UserAction = 'change-password' | 'bind-account' | 'bind-wx' | 'logout'

  interface UserInfoItem {
    label: string
    value?: string
    action?: UserAction
  }

  const handleItemClick = (action?: UserAction) => {
    if (!action) return
    if (action === 'change-password') {
      emit('open-change-password')
      return
    }
    if (action === 'bind-account') {
      emit('open-bind-account')
      return
    }
    if (action === 'bind-wx') {
      emit('open-bind-wx')
      return
    }
    userStore.logout()
  }

  const getNeedBindType = computed<string | null>(() => {
    if (!userStore.userInfo?.email) {
      return 'email'
    }
    if (!userStore.userInfo?.isBindVx) {
      return 'wx'
    }
    return null
  })

  const itemList = computed<UserInfoItem[]>(() => {
    const items: UserInfoItem[] = [
      {
        label: t('home.user.nickname'),
        value: userInfo.value?.nickname || '-',
      },
      {
        label: t('home.user.username'),
        value: userInfo.value?.username || '-',
      },
      {
        label: t('home.user.email'),
        value: userInfo.value?.email || '-',
      },
      {
        label: t('home.user.changePassword'),
        action: 'change-password',
      },
    ]

    if (getNeedBindType.value === 'email') {
      items.push({
        label: t('home.user.bindEmail'),
        action: 'bind-account',
      })
    }

    if (getNeedBindType.value === 'wx') {
      items.push({
        label: t('home.user.bindWechat'),
        action: 'bind-wx',
      })
    }

    items.push({
      label: t('home.user.logout'),
      action: 'logout',
    })

    return items
  })
</script>

<style lang="scss" scoped></style>
